import { EKeyInitiativeGoalMode } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/lpKeyInitiatives/components/keyInitiativeEditorModal/helpers/keyInitiativeGoalMode'

import { Translation } from 'cng-common/features/translations'

import { formatMoney } from '../../../helpers/formatMoney'
import { getFinGoalTypeTranslationKey } from '../../helpers/getFinGoal'
import { IListFinancialTotals } from '../../models'

import styles from './FinancialGoalTotals.module.scss'

interface IFinancialGoalTotalsProps {
  totals?: IListFinancialTotals
  activeCurrency: string
}

export const FinancialGoalTotals = ({ totals, activeCurrency }: IFinancialGoalTotalsProps) => (
  <div className={styles.root}>
    {[
      { mode: EKeyInitiativeGoalMode.RunRate, value: totals?.runRate },
      { mode: EKeyInitiativeGoalMode.Incremental, value: totals?.incremental },
    ].map(({ mode, value }) => (
      <div key={mode} className={styles.total}>
        <span>{value != null ? formatMoney(value, activeCurrency) : '-'}</span>
        <span className={styles.label}>
          <Translation text={getFinGoalTypeTranslationKey(mode)} span />
        </span>
      </div>
    ))}
  </div>
)
